var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","appear":"","type":"out-in"}},[(_vm.numeroAtual >= 0)?_c('span',[_vm._v("  "+_vm._s(_vm.numeroAtual)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }